var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"alert-container"},[_c('div',{class:['alert-message', `alert-${_vm.message.type}`]},[_c('i',{class:_vm.getIconClass(_vm.message.type)}),_c('span',[_vm._v(_vm._s(_vm.message.text))]),_c('button',{staticClass:"alert-close",on:{"click":_vm.removeMessage}},[_vm._v("×")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }